import PropTypes from "prop-types"
import React from "react"
import { connect } from "react-redux"
import withRouter from "components/Common/withRouter"

//i18n
import { withTranslation } from "react-i18next"
import SidebarContent from "./SidebarContent"

import { Link } from "react-router-dom"

import logoLightPng from "../../assets/images/large-logo.svg"
import logoLightSvg from "../../assets/images/logo-light.svg"
import SAR_logo from "assets/images/login/sar-logo-2.png"

const Sidebar = props => {
  return (
    <React.Fragment>
      <div className="vertical-menu">
        <div className="navbar-brand-box">

          <Link to="/" className="logo logo-light mt-1">
            {/* <span className="logo-sm">
              <img src={logoLightSvg} alt="" height="22" />
            </span> */}
            <span className="logo-lg">
              <img
                className="logo_large"
                src={SAR_logo}
                alt=""
                height="19"
              />
            </span>
          </Link>
        </div>
        <div data-simplebar className="h-100">
          {props.type !== "condensed" ? <SidebarContent /> : <SidebarContent />}
        </div>
        <div className="sidebar-background"></div>
      </div>
    </React.Fragment>
  )
}

Sidebar.propTypes = {
  type: PropTypes.string,
}

const mapStatetoProps = state => {
  return {
    layout: state.Layout,
  }
}
export default connect(
  mapStatetoProps,
  {}
)(withRouter(withTranslation()(Sidebar)))
